import { CircularProgress } from "@mui/material"
import React from "react"
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom"
import { AppErrorPage } from "@app/components/layout/AppErrorPage"
import { FrontUpdateBanner } from "@app/components/layout/FrontUpdateBanner"
import InfoSnackbar from "@app/components/layout/InfoSnackbar"
import { NavigationProgress } from "@app/components/layout/NavigationProgress"
import ErrorSnackbar from "@app/components/layout/error-snackbar"
import SuccessSnackbar from "@app/components/layout/success-snackbar"
import WarningSnackbar from "@app/components/layout/warning-snackbar"
import { DomainNameValidatorContextProvider } from "@app/core/context/organization/DomainNameValidatorContext"
import { pagesUrl } from "@app/core/appConstants"
import { applicationRoutes } from "./ApplicationRoutes"

// Keep the public entry independent of the authenticated pages and their BIM/admin dependencies.
export const appRoutes = [
  {
    id: "app-shell",
    // a page that fails: said in plain words, with the way back (instead of the raw error of the router)
    errorElement: <AppErrorPage />,
    element: (
      <ErrorSnackbar>
        <InfoSnackbar>
          <SuccessSnackbar>
            <WarningSnackbar>
              <DomainNameValidatorContextProvider>
                <NavigationProgress />
                <FrontUpdateBanner />
                <Outlet />
              </DomainNameValidatorContextProvider>
            </WarningSnackbar>
          </SuccessSnackbar>
        </InfoSnackbar>
      </ErrorSnackbar>
    ),
    children: [
      {
        id: "external-rsee",
        path: pagesUrl.BEEM_PILOT_DASHBOARD_EXTERNAL,
        lazy: async () => {
          const { ExternalRseeRoute } = await import("./ExternalRseeRoute")
          return { Component: ExternalRseeRoute }
        },
      },
      {
        // US 2580 — the shared dashboard of a Beem Shot variant
        id: "external-beem-shot",
        path: pagesUrl.BEEM_SHOT_DASHBOARD_EXTERNAL,
        lazy: async () => {
          const { ExternalBSRoute } = await import("./ExternalBSRoute")
          return { Component: ExternalBSRoute }
        },
      },
      ...applicationRoutes,
    ],
  },
]

export const router = createBrowserRouter(appRoutes)

export function AppRouter(): React.JSX.Element {
  return (
    <RouterProvider
      router={router}
      future={{ v7_startTransition: true }}
      fallbackElement={<CircularProgress aria-label="Chargement de la page" />}
    />
  )
}
